<template>
  <a-layout-sider
    :class="['sider', isDesktop() ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null]"
    width="256px"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null"
  >
    <logo />
    <s-menu
      :collapsed="collapsed"
      :menu="currentMenu"
      :theme="theme"
      :mode="mode"
      @select="onSelect"
      style="padding: 16px 0px;"
    ></s-menu>
    <div v-if="!collapsed" style="width:90%;margin:0 auto;padding:10px;border-radius:4px;margin-top:50px;line-height:180%;" class="ant-alert-info">
      <p style="color:#ffffff;font-size:14px;"><a-icon type="info-circle" style="margin-right:10px;font-size:18px;color:#1890ff"/>温馨提示：</p>
      <div v-html="notice()" ></div>
    </div>
  </a-layout-sider>
</template>

<script>
import Logo from '@/components/tools/Logo'
import SMenu from './index'
import { filterMenu } from '@/utils/util'
import appConfig from '@/config/app.config'
import { mixin, mixinDevice } from '@/utils/mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'SideMenu',
  components: { Logo, SMenu },
  mixins: [mixin, mixinDevice],
  props: {
    permission: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menus: {
      type: Array,
      required: true
    }
  },
  computed: {
    currentMenu() {
      // 通过环境，过滤菜单
      return appConfig.enableMenuPermit ? filterMenu(this.menus, this.permission) : this.menus
    }
  },
  methods: {
    ...mapGetters(['notice']),
    onSelect(obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>
